import type { LandingCourse } from "../types/landing.types";

export function formatInr(amount: number): string {
  return `₹ ${amount.toLocaleString("en-IN")}`;
}

export function getCourseTax(course: LandingCourse): number {
  if (course.totalPrice != null && course.price > 0) {
    return course.taxAmount ?? course.totalPrice - course.price;
  }
  if (course.taxPercentage != null && course.price > 0) {
    return Math.round((course.price * course.taxPercentage) / 100);
  }
  return course.taxAmount ?? 0;
}

export function getGstLabel(course: LandingCourse): string {
  if (course.taxPercentage != null) {
    const rate = Number.isInteger(course.taxPercentage)
      ? course.taxPercentage
      : parseFloat(course.taxPercentage.toFixed(2));
    return `Tax (${rate}% GST)`;
  }
  if (course.price > 0 && course.taxAmount > 0) {
    const rate = Math.round((course.taxAmount / course.price) * 100);
    return `Tax (${rate}% GST)`;
  }
  return "Tax";
}

export function getCourseTotal(course: LandingCourse): number {
  if (course.totalPrice != null) {
    return course.totalPrice;
  }
  return course.price + getCourseTax(course);
}
